import { AppState } from '../root.reducer';

export const getCurrentUserId = (state: AppState) => state.account.currentUserId;
export const getMeHasFetched = (state: AppState) => state.account.hasFetched;
export const getCurrentCustomerId = (state: AppState) => state.account.currentCustomerId;
export const getHasRequestedResetPassword = (state: AppState) => state.account.hasRequestedResetPassword;
export const getHasResetPassword = (state: AppState) => state.account.hasResetPassword;
export const getPersistedEmail = (state: AppState) => state.account.persistedEmail;
export const getHasSessionBeenCleared = (state: AppState) => state.account.hasSessionBeenCleared;
